var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { "append-to-body": "", visible: _vm.dialogVisible, width: "45%" },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "配发票收件人姓名:", prop: "userName" } },
            [
              _c("el-input", {
                staticStyle: { width: "2.5rem" },
                attrs: { size: "small", placeholder: "请填写姓名" },
                model: {
                  value: _vm.ruleForm.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "userName", $$v)
                  },
                  expression: "ruleForm.userName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "配发票收件手机号:", prop: "userPhone" } },
            [
              _c("el-input", {
                staticStyle: { width: "2.5rem" },
                attrs: { size: "small", placeholder: "请填写手机号" },
                model: {
                  value: _vm.ruleForm.userPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "userPhone", $$v)
                  },
                  expression: "ruleForm.userPhone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "详细地址", prop: "address" } },
            [
              _c("el-input", {
                staticStyle: { width: "4rem" },
                attrs: {
                  size: "small",
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入详细地址",
                },
                model: {
                  value: _vm.ruleForm.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "address", $$v)
                  },
                  expression: "ruleForm.address",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("ruleForm")
                },
              },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }